import { MsalAuthenticationResult, useMsal } from '@azure/msal-react';
import React, { FC } from 'react';
import { Card, Button } from 'antd';

export const AuthError: FC<MsalAuthenticationResult> = ({ error }) => {
    const { instance } = useMsal();

    const logout = () => {
        instance.logoutRedirect();
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Card title="Error de autenticación" style={{ width: 400, textAlign: 'center', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}>
                <p>{`Código de error: ${error ? error.errorCode : 'unknown error'}`}</p>
                <Button type="primary" onClick={logout}>
                    Cerrar Sesión
                </Button>
            </Card>
        </div>
    );
};
